/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const GATE_PASS_COLUMNS = [
  {
    id: "code",
    label: "Pass Code",
    accessorKey: "code",
    filterType: "text",
  },
  {
    id: "vehicle_number",
    label: "Vehicle",
    accessorKey: "vehicle_number",
    filterType: "text",
  },
  {
    id: "driver_name",
    label: "Driver",
    accessorKey: "driver_name",
    filterType: "text",
  },
  {
    id: "purpose",
    label: "Purpose",
    accessorKey: "purpose",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "INWARD_PADDY", label: "Inward — Paddy" },
      { value: "INWARD_STORE", label: "Inward — Store" },
      { value: "OUTWARD_RICE", label: "Outward — Rice" },
      { value: "VISITOR", label: "Visitor" },
    ],
    matchFilter: (row, value) => row.purpose === value,
  },
  {
    id: "party_name",
    label: "Party",
    accessorKey: "party_name",
    filterType: "text",
  },
  {
    id: "expected_variety",
    label: "Variety",
    accessorKey: "expected_variety",
    filterType: "text",
  },
  {
    id: "created_at",
    label: "Check In",
    accessorKey: "created_at",
    filterType: "date",
  },
  {
    id: "out_at",
    label: "Check Out",
    accessorKey: "out_at",
    filterType: "date",
  },
  {
    id: "status",
    label: "Status",
    accessorKey: "status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "IN", label: "IN" },
      { value: "OUT", label: "OUT" },
    ],
    matchFilter: (row, value) => row.status === value,
  },
  {
    id: "exit_request_status",
    label: "Exit",
    accessorKey: "exit_request_status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "PENDING", label: "Pending" },
      { value: "APPROVED", label: "Approved" },
      { value: "__NONE__", label: "None" },
    ],
    matchFilter: (row, value) => {
      if (value === "__NONE__") return !row.exit_request_status;
      return row.exit_request_status === value;
    },
  },
];
